// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import ContactUsForm from "@keller/App/Components/ContactUs/ContactUsForm";
import { xScreen } from "@keller/XDL/Utilities";
import React, { useContext } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface ContactUsFormStyles {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
}

const contactUsFormStyles: ContactUsFormStyles = {
    wrapper: {
        css: css`
            max-width: 462px;
            ${styledBoxStyle}
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
        css: css`
            margin-bottom: 15px;
        `,
    },
};

const styles = contactUsFormStyles;

const ContactUsFormLocation = () => {
    const { value: dealer } = useContext(DealerStateContext);

    if (!dealer) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="ContactUsFormLocation">
            <StyledWrapper>
                <Typography {...styles.title}>{translate("Get in touch")}</Typography>
            </StyledWrapper>
            <ContactUsForm location={dealer} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ContactUsFormLocation,
    definition: {
        group: "Dealer Details",
        allowedContexts: ["DealerDetailsPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
